import styled from 'styled-components'
import { rem } from 'utils/common'
import { device } from 'components/Variable'

export const HelpStyle = styled.div`
	padding: ${rem(40, 32)};
	background-color: ${({ theme }) => theme.color.secondary};
	@media (${device.tablet}) {
		order: 1;
		padding: ${rem(28, 20)};
	}
`
